import { z } from "zod";

/**
 * The response envelope every backend endpoint returns (docs/architecture/api-contracts.md).
 * `data` is left unknown here; each call validates it against its own schema.
 */
export const apiErrorItemSchema = z.object({
  code: z.string(),
  message: z.string(),
  field: z.string().nullish(),
});

export const paginationSchema = z.object({
  page: z.number().int(),
  pageSize: z.number().int(),
  totalCount: z.number().int(),
  totalPages: z.number().int(),
  hasNext: z.boolean(),
  hasPrevious: z.boolean(),
});

export const envelopeSchema = z.object({
  success: z.boolean(),
  statusCode: z.number().int(),
  message: z.string().nullish(),
  data: z.unknown().optional(),
  errors: z.array(apiErrorItemSchema).nullish(),
  pagination: paginationSchema.nullish(),
  traceId: z.string().nullish(),
});

export type ApiErrorItem = z.infer<typeof apiErrorItemSchema>;
export type Pagination = z.infer<typeof paginationSchema>;
export type ApiEnvelope = z.infer<typeof envelopeSchema>;

/** For 204 / empty-body endpoints such as logout or delete. */
export const noContentSchema = z.unknown().transform((): void => undefined);

/** `data` is an array of `item` and the envelope carries `pagination`. */
export function paginatedSchema<T>(item: z.ZodType<T>) {
  return z.object({
    data: z.array(item),
    pagination: paginationSchema,
  });
}

export interface Paginated<T> {
  items: T[];
  pagination: Pagination;
}
